import { isDefined, syntaxFNMA } from '@aloft/toolkit-shared';

import { extractAdjustmentDescription } from './extractAdjustmentDescription.js';

export function extractCarStorage(sale: Element): {
  garageSpaces?: syntaxFNMA.ParkingSpaceNumber;
  carportSpaces?: syntaxFNMA.ParkingSpaceNumber;
} {
  try {
    const { attachedGarageSpaces, builtInGarageSpaces, detachedGarageSpaces, carportSpaces } =
      syntaxFNMA.garageCarportSyntax.decode(
        extractAdjustmentDescription(sale, 'CarStorage', 'Parking') ?? '',
      );

    const garageList = [attachedGarageSpaces, builtInGarageSpaces, detachedGarageSpaces];
    const garageSpaces = garageList.some(isDefined)
      ? syntaxFNMA.schParkingSpaceNumber.parse(garageList.reduce((acc, val) => acc + (val ?? 0), 0))
      : undefined;

    return {
      garageSpaces,
      carportSpaces,
    };
  } catch (e: unknown) {
    console.warn('Failed to parse car storage', e);
    return {};
  }
}
